// @ts-nocheck
import * as dateConverter from 'Common/DateConverter';
import TimeAgo from 'javascript-time-ago';
import nb from 'javascript-time-ago/locale/nb';
import { format, utcToZonedTime } from "date-fns-tz";
TimeAgo.addDefaultLocale(nb);

$(() => {
    var dateElements = $('[data-to-local-time-date-utc]');
    formatDatesToLocalTime(dateElements);
});

export function formatDatesToLocalTime(dateElements: JQuery) {
    if (dateElements && dateElements.length) {
        const timeAgo = new TimeAgo();
        $.each(dateElements,
            (index, el) => {
                let $el = $(el);
                if ($el.hasClass('date-ago')) {
                    const utc = $(el).data('to-local-time-date-utc');
                    const date = utcToZonedTime(utc, Intl.DateTimeFormat().resolvedOptions().timeZone);
                    $el.text(timeAgo.format(date));
                    $el.attr('title', format(utcToZonedTime(date, Intl.DateTimeFormat().resolvedOptions().timeZone), 'yyyy.MM.dd HH.mm.ss'));
                } else {
                    $el.text(dateConverter.convertToLocalTimeZoneDate($(el).data('to-local-time-date-utc')));
                }
            });
    }
}

/**
 * Pretty Print JSON Objects.
 * Inspired by http://jsfiddle.net/unLSJ/
 *
 * @return {string}    html string of the formatted JS object
 * @example:  var obj = {"foo":"bar"};  obj.prettyPrint();
 */
export function prettyPrintJson(json) {
    var jsonLine = /^( *)("[\w]+": )?("[^"]*"|[\w.+-]*)?([,[{])?$/mg;
    var replacer = function(match, pIndent, pKey, pVal, pEnd) {
        var key = '<span class="json-key" style="color: brown">',
            val = '<span class="json-value" style="color: navy">',
            str = '<span class="json-string" style="color: olive">',
            r = pIndent || '';
        if (pKey)
            r = r + key + pKey.replace(/[": ]/g, '') + '</span>: ';
        if (pVal)
            r = r + (pVal[0] == '"' ? str : val) + pVal + '</span>';
        return r + (pEnd || '');
    };

    return JSON.stringify(json, null, 3)
        .replace(/&/g, '&amp;').replace(/\\"/g, '&quot;')
        .replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(jsonLine, replacer);
}

$(() => {
    var dateElements = $('[data-to-local-time-hour-minute-utc]');
    if (dateElements && dateElements.length) {
        $.each(dateElements,
            (index, el) => {
                el.innerText = dateConverter.convertToLocalTimeZoneHourMinute($(el).data('to-local-time-hour-minute-utc'));
            });
    }

    var json = $('.pretty');
    if (json && json.length) {
        $.each(json,
            (index, el) => {
                var e  = prettyPrintJson(JSON.parse(el.innerText));
                $(el).html(e);
            });
    }
});